<h1 mat-dialog-title fxLayoutAlign="center">{{ 'debug_info.title' | transloco }}</h1>
<div mat-dialog-content>
  <div class="configuration-item-root" *ngFor="let entry of debugInfoEntries">
    {{ entry[0] }} : {{ entry[1] }}
  </div>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button type="button" [cdkCopyToClipboard]="debugInfoAsJSON">{{ 'debug_info.copy' | transloco }}</button>
  <button mat-flat-button type="button" color="primary" (click)="close()">{{ 'close' | transloco }}</button>
</div>